import React from 'react';
import LoginForm from '../../components/LoginForm/LoginForm';
import { MainLogo } from '../../components/MainLogo';

export default function LoginPage() {
    return (
        <div className="login__wrapper">
            <header className="login__header">
                <a href="/">
                    <MainLogo />
                </a>
            </header>
            <LoginForm />
        </div>
    );
}
